import { mergeClasses } from '@fluentui/react-components';
import { memo, useMemo } from 'react';
import { useGenericIconStyles } from './GenericIcon.styles';
import { IconProps, StyledIconType } from './StyledIconProps';
import { CustomerItemStatus } from '../../store/features/customerUpdates/customerUpdatesSlice';

export const customerItemStatusToIconType = (
    status: CustomerItemStatus
): StyledIconType => {
    switch (status) {
        case 'NotNotified':
            return 'danger';
        case 'UnableToNotify':
            return 'warning';
        case 'Notified':
            return 'success';
    }
};

export interface StyledIconProps extends IconProps {
    successIcon?: React.ReactNode;
    warningIcon?: React.ReactNode;
    dangerIcon?: React.ReactNode;
}

const StyledIcon = memo(
    ({
        interactive = false,
        width = 20,
        height = 20,
        type = 'success',
        successIcon,
        warningIcon,
        dangerIcon,
        className,
    }: StyledIconProps) => {
        const styles = useGenericIconStyles();

        const [iconStyle, icon] = useMemo(() => {
            switch (type) {
                case 'success':
                    return [styles.rootSuccess, successIcon];
                case 'warning':
                    return [
                        styles.rootWarning,
                        warningIcon || dangerIcon || successIcon,
                    ];
                case 'danger':
                    return [styles.rootDanger, dangerIcon || successIcon];
                default:
                    return [styles.rootSuccess, undefined];
            }
        }, [type, styles, successIcon, warningIcon, dangerIcon]);

        return (
            <svg
                className={mergeClasses(
                    iconStyle,
                    interactive ? styles.interactive : '',
                    className
                )}
                width={width}
                height={height}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {icon}
            </svg>
        );
    }
);

export default StyledIcon;
